import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { ThemeMode } from 'config';
import logoIcon3 from 'assets/images/sidelogo.png';

// ==============================|| LOGO SVG ||============================== //

const LogoMain = () => {
  const theme = useTheme();
  return (
    <img src={theme.palette.mode === ThemeMode.DARK ? logoIcon3 : logoIcon3} alt="icon logo" width="190" height="45" />
    // <img src={theme.palette.mode === ThemeMode.DARK ? logoIcon3 : logoIcon3} alt="icon logo" />
  );
};

LogoMain.propTypes = {
  reverse: PropTypes.bool
};

export default LogoMain;
